import React from "react";


function Hero() {
  return (
    <section
      id="hero"
      className="hero"
     
    >
      <div className="container">
        <h2>Together, We Can Give Animals a Loving Home</h2>
        <div className="cta-buttons">
          <a href="#adopt" className="btn">
            Find a Pet to Adopt
          </a>
          <a href="upi://pay?pa=7001072985@axl&pn=abhay&cu=INR&am" className="btn">
            Donate Today
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
